module.exports = __webpack_public_path__ + "media/images/icon-close-ticket-6127aa4d750e32d43f2604fa394f344e.svg";